import React  from "react";
import Footer from './components/footer';
import Header from './components/header';
import './App.css';

function App() {

    return (
        <div className="App">
            <Header/>
            <Footer/>
        </div>
    );
}

export default App;